import {
  SignaturePad,
  type SignaturePadDrawEndDetails,
} from "@ark-ui/react";

export type SignaturePadFieldProps = {
  label?: string;
  disabled?: boolean;
  onSignedChange?: (assinado: boolean, imagemDataUrl?: string | null) => void;
};

export function SignaturePadField({
  label = "Assine abaixo",
  disabled = false,
  onSignedChange,
}: SignaturePadFieldProps) {
  return (
    <SignaturePad.Root
      disabled={disabled}
      onDrawEnd={(details: SignaturePadDrawEndDetails) => {
        if (details.paths.length === 0) {
          onSignedChange?.(false, null);
          return;
        }
        void details
          .getDataUrl("image/png")
          .then((dataUrl) => onSignedChange?.(true, dataUrl || null))
          .catch(() => onSignedChange?.(true, null));
      }}
    >
      <SignaturePad.Label className="mb-1.5 block text-sm font-medium text-neutral-800">
        {label}
      </SignaturePad.Label>
      <SignaturePad.Control className="relative h-36 w-full touch-none rounded-lg border border-neutral-300 bg-neutral-50">
        <SignaturePad.Segment className="h-full w-full fill-neutral-900 stroke-neutral-900" />
        <SignaturePad.ClearTrigger asChild>
          <button
            type="button"
            className="absolute right-2 top-2 rounded-md px-2 py-1 text-xs font-medium text-neutral-500 hover:bg-white hover:text-neutral-800"
            onClick={() => onSignedChange?.(false, null)}
          >
            Limpar
          </button>
        </SignaturePad.ClearTrigger>
        <SignaturePad.Guide className="absolute bottom-5 left-3 right-3 border-b border-dashed border-neutral-400" />
      </SignaturePad.Control>
    </SignaturePad.Root>
  );
}

export default SignaturePadField;
